
import Popup from 'vux/src/components/popup/index.vue'


export default {
name: 'time-popup',
components: {
Popup,
},
props: {
value: {
type: Boolean,
default: false,
},
timeData: {
type: Array,
default(){
return [];
},
},
},
data(){
return {
selectTime: '',
};
},
computed: {
show: {
get(){
return this.value;
},
set(val){
this.$emit('input', val);
}
}
},
methods: {
onHidePop(){
this.$emit('input', false);
},

/** 选择到店时间 */
onSelectTime(ev, time){
ev.stopPropagation();
this.onHidePop();
this.selectTime = time;
this.$emit('on-time', time);
},
},
}



// WEBPACK FOOTER //
// ./src/views/hotel-booking/components/TimePopup.vue